import { useEffect } from 'react';
import { useAppSelector } from '@redux/hooks';
import { authSelectors } from '@redux/auth';
import { setUser } from '@services';

export const useAnalytics = () => {
  const { data } = useAppSelector(authSelectors.getProfileAPIData);

  useEffect(() => {
    if (data?.id) {
      setUser(data?.id);
    }
  }, [data?.id]);
};
